import { RcFile } from "antd/es/upload";
import { Product } from "./product";
import { SaleItemState } from "./sales";

export const FieldSplitor = '<->';

export enum ProductInfoStateEnum {
  DISABLED,
  NORMAL,
}

export interface ProductInfoAttachmentAdd {
  docId: string;
  description?: string;
}
export interface ProductInfoAttachment {
  id?: string;                           // 附件ID，用于更新/删除操作
  docId: string;
  description?: string;
  fileTemp?: RcFile
}

export interface ProductInfoAdd {
  saleItemId: string;                  // 销售订单明细ID，必填
  productId: string;                   // 产品ID，必填
  issueDate?: number;                  // 发布日期，可空
  customerName?: string;               // 客户名称，可空
  customerModel?: string;              // 客户型号，可空
  companyModel?: string;               // 公司型号，可空
  productionSoftware?: string;         // 生产软件，可空
  flash?: string;                       // Flash软件，可空
  md5Value?: string;                    // MD5值，可空
  checksum?: string;                    // 校验和，可空
  qaToolVersion?: string;               // QA工具版本，可空
  softwareVersion?: string;             // 软件版本，可空
  macAddressContent?: string;           // MAC地址内容，可空
  quantity?: string;                    // 数量，可空
  size?: string;                        // 尺寸，可空
  antivirusStatus?: string;             // 杀毒状态，可空
  languageRequirement?: number;         // 语言要求(1=中文,2=英文等)，可空
  ssid?: string;                        // SSID，可空
  initialIp?: string;                   // 初始IP，可空
  finishedToolVersion?: string;         // 成品工具版本，可空
  semiFinishedToolVersion?: string;     // 半成品工具版本，可空
  channelRange?: number;                // 信道范围，可空
  channelSelection?: number;            // 信道选择，可空
  defaultChannel?: number;              // 默认信道，可空
  functionDescription?: string;         // 功能描述，可空
  productionTestProgram?: string;       // 生产测试程序，可空
  power?: string;                       // 功率，可空
  evm?: string;                         // EVM，可空
  fer?: string;                         // FER，可空
  smt?: string;                         // SMT，可空
  dip?: string;                         // DIP，可空
  test1?: string;                       // 测试1，可空
  assy?: string;                        // 组装，可空
  test2?: string;                       // 测试2，可空
  pack?: string;                        // 包装，可空
  shipmentRequirements?: string;        // 发货要求，可空
  attachments?: ProductInfoAttachment[]; // 附件列表，可空
}


// ProductInfo数据
export interface ProductInfoData {
  id: string;                           // 生产说明书ID，非空
  saleItemId: string;                  // 销售订单明细ID，非空
  productId: string;                   // 产品ID，非空
  issueDate?: number;                  // 发布日期，可空
  customerName?: string;               // 客户名称，可空
  customerModel?: string;              // 客户型号，可空
  companyModel?: string;               // 公司型号，可空
  productionSoftware?: string;         // 生产软件，可空
  flash?: string;                       // Flash软件，可空
  md5Value?: string;                    // MD5值，可空
  checksum?: string;                    // 校验和，可空
  qaToolVersion?: string;               // QA工具版本，可空
  softwareVersion?: string;             // 软件版本，可空
  macAddressContent?: string;           // MAC地址内容，可空
  quantity?: string;                    // 数量，可空
  size?: string;                        // 尺寸，可空
  antivirusStatus?: string;             // 杀毒状态，可空
  languageRequirement?: number;         // 语言要求，可空
  ssid?: string;                        // SSID，可空
  initialIp?: string;                   // 初始IP，可空
  finishedToolVersion?: string;         // 成品工具版本，可空
  semiFinishedToolVersion?: string;     // 半成品工具版本，可空
  channelRange?: number;                // 信道范围，可空
  channelSelection?: number;            // 信道选择，可空
  defaultChannel?: number;              // 默认信道，可空
  functionDescription?: string;         // 功能描述，可空
  productionTestProgram?: string;       // 生产测试程序，可空
  power?: string;                       // 功率，可空
  evm?: string;                         // EVM，可空
  fer?: string;                         // FER，可空
  smt?: string;                         // SMT，可空
  dip?: string;                         // DIP，可空
  test1?: string;                       // 测试1，可空
  assy?: string;                        // 组装，可空
  test2?: string;                       // 测试2，可空
  pack?: string;                        // 包装，可空
  shipmentRequirements?: string;        // 发货要求，可空
  attachments?: ProductInfoAttachment[]; // 附件列表，可空
  saleOrderItem?: SaleItemState;         // 销售订单明细，可空
  product?: Product;                    // 产品信息，可空
  createdAt: number;                   // 创建时间，非空
  updatedAt: number;                   // 更新时间，非空
}
